"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderContractsResponse = exports.ProviderContract = exports.TechnicalResource = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class TechnicalResource extends base_models_1.Serializable {
}
exports.TechnicalResource = TechnicalResource;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'ZH',
        description: 'Technical resource type',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], TechnicalResource.prototype, "technicalResourceType", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'ZH',
        description: 'NL-ESS-20240902-CC-01',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], TechnicalResource.prototype, "technicalResourceID", void 0);
class ProviderContract extends base_models_1.Serializable {
}
exports.ProviderContract = ProviderContract;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '12344424',
        description: 'Provider contract id',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ProviderContract.prototype, "providerContractId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '12344424',
        description: 'Account id',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ProviderContract.prototype, "accountID", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '12344424',
        description: 'Business agreement id',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ProviderContract.prototype, "businessAgreementId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '2024-05-05',
        description: `Valid from`,
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDateString)(),
    tslib_1.__metadata("design:type", String)
], ProviderContract.prototype, "validFrom", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '2024-05-05',
        description: `Valid to`,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    tslib_1.__metadata("design:type", String)
], ProviderContract.prototype, "validTo", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: [
            {
                technicalResourceType: 'ZB',
                technicalResourceID: 'NL-ESS-20240902-CC-01',
            },
        ],
        description: 'Technical Resource',
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => TechnicalResource),
    tslib_1.__metadata("design:type", Array)
], ProviderContract.prototype, "technicalResources", void 0);
class ProviderContractsResponse extends base_models_1.Serializable {
}
exports.ProviderContractsResponse = ProviderContractsResponse;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: [
            {
                providerContractId: '111',
                accountID: '1111',
                businessAgreementId: '555',
                validFrom: '2024-02-29',
                validTo: '2025-02-29',
                technicalResources: [
                    {
                        technicalResourceType: 'ZB',
                        technicalResourceID: 'NL-ESS-20240902-CC-01',
                    },
                ],
            },
        ],
        description: 'Provider contracts',
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ProviderContract),
    tslib_1.__metadata("design:type", Array)
], ProviderContractsResponse.prototype, "results", void 0);
